import { formUrl } from 'shared/utils/links/form-url'

export const getConnectionWebhookBaseUrl = () =>
  formUrl('/api/payment/integration/secure-and-pay/webhook', false)
